module.exports = __webpack_public_path__ + "media/bangkok/bangkok white2-3b5d8c68.jpg";